import { addDays } from 'date-fns'
import { sortedLastIndexBy } from 'lodash'
import { IEvent } from '../../../models/Event'
import { IRoomWithEvents } from '../../../reducers/bookingCalendar/selectors/rooms'

export const findEventByRoomDay = (
  room: IRoomWithEvents,
  day: Date,
): IEvent['id'] | null => {
  const minusDay = addDays(day, 1)
  const compare = (obj, date, minusDay) =>
    +date >= +obj.startDate && +minusDay <= +obj.finishDate
  if (!room.events) return null

  const eventIndex = sortedLastIndexBy(
    room.events,
    { startDate: day } as Partial<IEvent>,
    re => {
      return +re.startDate
    },
  )

  if (eventIndex) {
    const event = room.events[eventIndex - 1]
    if (event && compare(event, day, minusDay)) {
      return event.id
    }
  }

  return null
}
